import React from "react";

import { useTranslation } from "react-i18next";
import { ChallengeBadges_memberBadgesByCategory_challengeProgress } from "../../../types/__generated__/ChallengeBadges";
import { I18N_NAMESPACES } from "../../../helpers/constants";
import { ProgressContainer, BarContainer, TotalStatusBar, CurrentProgressBar, ProgressText } from "./style";

interface ChallengeProgressProps {
  challengeProgress: ChallengeBadges_memberBadgesByCategory_challengeProgress | null | undefined;
  numberOfTotalBadges: number;
  numberOfEarnedBadges: number;
}

const ChallengeProgress = ({
  challengeProgress,
  numberOfTotalBadges,
  numberOfEarnedBadges,
}: ChallengeProgressProps) => {
  const { t } = useTranslation([I18N_NAMESPACES.MY_BADGES]);

  const hasStartedChallenge = !!challengeProgress?.challengeStatus;

  const ratioCompleted =
    hasStartedChallenge && numberOfTotalBadges > 0 ? numberOfEarnedBadges / numberOfTotalBadges : 0;
  const percentCompleted = ratioCompleted * 100;

  const progressText = t("myBadges:challengeProgressRatio", {
    numberOfTotalBadges,
    numberOfEarnedBadges,
  });

  const renderStatusBar = () => (
    <BarContainer>
      <TotalStatusBar />
      <CurrentProgressBar ratio={ratioCompleted} percentage={`${percentCompleted}%`} />
    </BarContainer>
  );

  return (
    <ProgressContainer>
      {renderStatusBar()}
      <ProgressText>{progressText}</ProgressText>
    </ProgressContainer>
  );
};

export default ChallengeProgress;
